import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import DialogInput from '../../../components/advanced/DialogInput';
import Button from '../../../components/basic/Button';
import { formInput, formError, initializeStoreRemoveDiscount } from '../../../../actions/FormActions';
import CheckInput from '../../../components/basic/CheckInput';
import { selectPOSRemoveDiscountModel } from '../../../../selectors/entitySelector';
import { removeDiscountOrder, removeDiscountProductsOrder } from '../../../../actions/EntityActions';
import { showError, showSnackbar } from '../../../../actions/CommonActions';
import { OrderRemoveType, OrderDiscountType } from '../../../../constants/enums';
import DialogHeader from '../../../components/basic/DialogHeader';

const dialogStyle = {
    width: '65%',
    maxWidth: 'none'
};

class POSRemoveDiscountDialog extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            orderRemoveType: null
        };
    }

    componentWillReceiveProps = (newProps) => {
        if ((newProps.saveSuccess != undefined && newProps.saveSuccess !== this.props.saveSuccess)
            || (newProps.saveError != undefined && newProps.saveError !== this.props.saveError)) {
            // if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess === true)
                this.saveSuccess();
            else if (newProps.saveSuccess === false && newProps.saveError) {
                const errorCode = newProps.saveError.split('-')[0];
                this.saveFailure(errorCode);
            }
        }

        if (this.props.open === false && newProps.open === true) {
            // if discounts exists set the local state with type of removal (Order or Product level)
            if (this.props.order.products.filter(item => item.discountType !== null && item.discountType !== OrderDiscountType.Order).length > 0) {
                this.setState({ orderRemoveType: OrderRemoveType.Product });
            }
            else {
                this.setState({ orderRemoveType: OrderRemoveType.Order });
            }
        }
    }

    saveSuccess = () => {
        this.onClose();
        this.props.showSnackbar(this.props.t('pos.removeDiscountDialog.saveSuccessMessage'));
    }

    saveFailure = (errorCode) => {
        if (errorCode && errorCode == 9) {
            this.props.showError(this.props.t('pos.messages.invalidCredentialsDiscount'));
        }
        else 
          if(errorCode && errorCode == 4){
            this.props.showError(this.props.t('pos.messages.orderUpdatedElsewhereMessage'))
        }
        else {
            this.props.showError(this.props.t('pos.removeDiscountDialog.saveErrorMessage'));
        }
    }

    onClose = () => {
        this.props.onClose();
        this.setState({ orderRemoveType: null });
        this.props.initializeStore();
    }

    removeDiscount = () => {
      const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
      const { stackDiscountsEnabled, model, order, branchId, userPin } = this.props;
      const baseModel = {
        orderId: order.id,
        branchId: branchId,
        deviceId: deviceData.id,
        employeeId: userPin.employee.id,
        modifiedDate: order.modifiedDate
      };

      const removeStackDiscount = () => {
        if (model.orderData.length > 0 || model.productData.length > 0) {
          this.props.removeDiscountOrder({
            ...baseModel,
            OrderDiscountIds: model.orderData,
            ProductDiscountIds: model.productData
          });
        } else {
          this.props.showError(this.props.t('pos.removeDiscountDialog.selectDiscountFromOrderOrProduct'));
        }
      };

      const removeRegularDiscount = () => {
        if (this.state.orderRemoveType !== null && model && model.length > 0) {
          let payload;
          if (this.state.orderRemoveType === OrderRemoveType.Order) {
            payload = {
              ...baseModel,
              orderDiscountIds: model
            };
            this.props.removeDiscountOrder(payload);
          } else {
            payload = {
              ...baseModel,
              productsId: model
            };
            this.props.removeDiscountProductsOrder(payload);
          }
        } else {
          this.props.showError(this.props.t('pos.removeDiscountDialog.selectDiscountFromOrder'));
        }
      };

      stackDiscountsEnabled ? removeStackDiscount() : removeRegularDiscount();
    };

    getCombinedDiscountMap = () => {
      const p = this.props;
      const { products, discounts } = p.order;
      let pricebyQuantityCampaigns = [];

      const productDiscounts = products.flatMap((item) => {
          if (item.discountType === null || item.discountType === OrderDiscountType.Order) return [];
          return item.productDiscountList.map((discount) => {
              const discountText = discount.type === "Percentage"
                  ? `${discount.percentage.toFixed(0)} %`
                  : `$ ${discount.amount.toFixed(2)}`;
              const discoutNote = discount.notes ? `- ${discount.notes}` : ""

              if (discount.campaignApplyPriceByQuantity){
                pricebyQuantityCampaigns.push({
                  id: discount.id,
                  type: discount.type,
                  percentage: discount.percentage,
                  amount: discount.amount,
                  discountNote: discoutNote,
                  productName: item.name,
                  campaignId: discount.campaignId
                })
              } else {
                return (
                    <CheckInput
                        name={`${p.name}RemoveProductDiscount-${discount.id}`}
                        key={discount.id}
                        text={`${this.props.t('pos.removeDiscountDialog.discoundOfProduct', { discountText: discountText, name: item.name, note: discoutNote })}`}
                        className="discountRemoveTextColor"
                        value={discount.id}
                    />
                );
              }
              });
          });

          const pricebyQuantityCampaignsGrouped = pricebyQuantityCampaigns.length > 0 ? pricebyQuantityCampaigns.reduce((group, discount) => {
            const { id, type, percentage, amount, discountNote, productName, campaignId } = discount;
    
            if (!group[campaignId]) {
                group[campaignId] = { 
                  id: [id],
                  type: type,
                  totalDiscountAmount: type === "Percentage" ? percentage : amount, 
                  discountNote: discountNote, 
                  productName: productName,
                  campaignId: campaignId
                };
            } else {
              group[campaignId].id.push(id);
              if (type === "Amount") {
                group[campaignId].totalDiscountAmount += amount
              }
            }             
            return group;
        }, {}) : null;
    
          const pricebyQuantityDiscounts = []
          for (const campaignId in pricebyQuantityCampaignsGrouped) {
            let data = pricebyQuantityCampaignsGrouped[campaignId]
    
            const discountText = data.type === "Percentage" ? `${data.totalDiscountAmount.toFixed(0)} %` : `$ ${data.totalDiscountAmount.toFixed(2)}`;
            pricebyQuantityDiscounts.push(
                <CheckInput
                    name={`${p.name}RemovePriceByQuantityDiscount-${data.id}`}
                    key={data}
                    text={`${this.props.t('pos.removeDiscountDialog.discoundOfProductAll', { discountText: discountText, name: data.productName, note: data.discountNote })}`}
                    className="discountRemoveTextColor"
                    value={data.campaignId}
                />
            );
          }
          const orderDiscounts = discounts.map((item, index) => {
              const discountText = `$ ${item.amount.toFixed(2)}${item.type === OrderDiscountType.Percentage ? ` (${item.percentage.toFixed(0)}%)` : ''}`;
              return (
                  <CheckInput
                      name={`${p.name}RemoveDiscount-${item.id}`}
                      key={index + products.length}
                      text={`${this.props.t('pos.removeDiscountDialog.discoundOfEntireOrder', { discountText: discountText })}`}
                      className="discountRemoveTextColor"
                      value={item.id}
                  />
              );
          });
          return [...productDiscounts, ...pricebyQuantityDiscounts, ...orderDiscounts];
  }

  getProductDiscountMap = () => {
    const p = this.props;
    let pricebyQuantityCampaigns = [];

    const productDiscounts = p.order.products.map((item, index) => {
      if (item.discountType === null || item.discountType === OrderDiscountType.Order)
        return null;
      
      const discoutNote = item.notes ? `- ${item.notes}` : ""
      if (item.campaignApplyPriceByQuantity){
          pricebyQuantityCampaigns.push({
            id: item.id,
            type: item.discountType,
            discountAmount: item.discountAmount,
            discountNote: discoutNote,
            productName: item.name,
            campaignId: item.campaignId
          })
        } else {
          return (
            <CheckInput name={p.name + "RemoveDiscount-" + item.id}
              key={index}
              text={`${this.props.t('pos.page.discountOf')} ${item.discountType === OrderDiscountType.Percentage ? `${item.discountAmount.toFixed(0)} %` : `$ ${item.discountAmount.toFixed(2)}`} ${this.props.t('pos.removeDiscountDialog.forProduct')} ${item.name} ${discoutNote}`}
              className="discountRemoveTextColor"
              value={item.productId} />
          );
        }
    })

    const pricebyQuantityCampaignsGrouped = pricebyQuantityCampaigns.length > 0 ? pricebyQuantityCampaigns.reduce((group, discount) => {
      const { id, type, discountAmount, discountNote, productName, campaignId } = discount;

      if (!group[campaignId]) {
          group[campaignId] = { 
            id: [id],
            type: type,
            totalDiscountAmount: discountAmount,
            discountNote: discountNote,
            productName: productName,
            campaignId: campaignId
          };
      } else {
        group[campaignId].id.push(id);
        if (type === "Amount") {
          group[campaignId].totalDiscountAmount += discountAmount
        }
      }             
      return group;
     }, {}) : null

    const pricebyQuantityDiscounts = []
    for (const campaignId in pricebyQuantityCampaignsGrouped) {
      let data = pricebyQuantityCampaignsGrouped[campaignId]
      pricebyQuantityDiscounts.push(
        <CheckInput name={p.name + "RemovePriceByQuantityDiscount-" + data.id}
        key={data}
        text={`${this.props.t('pos.page.discountOf')} ${data.type === OrderDiscountType.Percentage ? `${data.totalDiscountAmount.toFixed(0)} %` : `$ ${data.totalDiscountAmount.toFixed(2)}`} ${this.props.t('pos.removeDiscountDialog.forProduct')} ${data.productName} (${this.props.t('pos.productCategories.all')}) ${data.discountNote}`}
        className="discountRemoveTextColor"
        value={data.campaignId} />
      );
    }
    return [...productDiscounts, ...pricebyQuantityDiscounts];
  }
  render() {
        const { t } = this.props; 
    const p = this.props;
    const { stackDiscountsEnabled } = this.props;
    let combinedDiscountMap = stackDiscountsEnabled ? this.getCombinedDiscountMap(): [];
        // when a discount exists, show the list
        return (p.order && p.order.hasDiscounts) ? (
            <div>
                <DialogInput
                    title={<div className="modal-title p-0">
                        <DialogHeader text={`${t('pos.removeDiscountDialog.title')}${p.orderId} `} />
                        </div>}
                    modal={true}
                    open={p.open}
                    autoScrollBodyContent={true}
                    contentStyle={dialogStyle}
                    actions={[
                        <Button
                            key={2}
                            type="CancelButton"
                            name="buttonCancel"
                            className="btn-space"
                            label={t('common.cancel')}
                            onTouchTap={() => this.onClose()} />,
                        <Button
                            key={1}
                            name="removeDiscount"
                            label={t('pos.removeDiscountDialog.removeDiscount')}
                            primary={true}
                            className="btnNewBrandPOS"
                            onTouchTap={() => this.removeDiscount()} />
                    ]}>
                    <div>
                        <br />
                        <p className="purpleText">{t('pos.removeDiscountDialog.existingDiscountForOrder')}
                          {t('pos.removeDiscountDialog.removeDiscountFirst')}
                            </p>
                        <br />
                        <div className="row">
                            <div className="col-lg-12">
                                {
                                  stackDiscountsEnabled ? (
                                    combinedDiscountMap
                                  ) : (
                                    this.state.orderRemoveType === OrderRemoveType.Product ? (
                                      this.getProductDiscountMap()
                                    ) : (
                                      p.order.discounts.map((item, index) => {
                                        return (
                                          <CheckInput name={p.name + "RemoveDiscount-" + item.id}
                                            key={index}
                                            text={`${t('pos.page.discountOf')} $ ${item.discountedValue.toFixed(2)}${item.type === OrderDiscountType.Percentage ? ` (${item.percentage.toFixed(0)}%)` : ''} ${t('pos.removeDiscountDialog.forEntireOrder')}`}
                                            className="discountRemoveTextColor"
                                            value={item.id} />
                                        );
                                      })
                                    )
                                  )
                                }
                            </div>
                        </div>
                    </div>
                </DialogInput>
            </div>
        ) : null;
    }
}

function mapStateToProps(state, ownProps) {
    return {
        model: selectPOSRemoveDiscountModel(state, ownProps.name, state.common.applicationSettings.stackDiscountsEnabled),
        deviceKeyName: state.common.applicationSettings.deviceKeyName,
        saveSuccess: state.form[`${ownProps.name}SaveSuccess`],
        saveError: state.form[`${ownProps.name}SaveError`],
        order: state.entity.posOrder,
        branchId: state.common.branchId,
        userPin: JSON.parse(sessionStorage.getItem('pinUser')) ? JSON.parse(sessionStorage.getItem('pinUser')) : state.entity.pin,
        stackDiscountsEnabled: state.common.applicationSettings.stackDiscountsEnabled,
        // orderProducts: state.entity.posOrder.products
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        formInput: (value, name) => dispatch(formInput(value, name)),
        removeDiscountOrder: (model) => dispatch(removeDiscountOrder(model, ownProps.name)),
        removeDiscountProductsOrder: (model) => dispatch(removeDiscountProductsOrder(model, ownProps.name)),
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        showError: (message) => dispatch(showError(message)),
        formError: (name, error) => dispatch(formError(name, error)),
        initializeStore: () => dispatch(initializeStoreRemoveDiscount(ownProps.name))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSRemoveDiscountDialog))